module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS12.0d65d258.jpg";